module.exports = __webpack_public_path__ + "media/images/icons/browser-86efd4c1a3b41c81d945dd0f00cad79a.svg";